import { Component } from '@angular/core';

@Component({
  selector: 'shared-about-loader',
  templateUrl: './about-loader.component.html',
  styleUrls: ['./about-loader.component.scss'],
})
export class AboutLoaderComponent {
}
